import React from 'react';
import { Provider } from 'react-redux';
import Index from './Index';
import configureStore from '../../configureStore';
import GraphQLClient from 'graphql-js-client';
import types from '../../schema/types.js';
import { settingsSelectImage } from '../../actions/settings';

export default class App extends React.Component {

  constructor(props) {
    super(props)
  }

  async getProduct(query, search) {
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/${this.props.apiVersion}/graphql.json`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`
        }
      }
    });
    const response = await client.send(query).then(({model, data}) => {
      return data.product;
    })
    return {product: response, search: search}
  }

  render() {
    let _this = this;
    let initialState;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(window.location.search && urlParams.get('background') != null) {
      const client = new GraphQLClient(types, {
        url: `https://${this.props.shop.shopify_domain}/api/${this.props.apiVersion}/graphql.json`,
        fetcherOptions: {
          headers: {
            'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`
          }
        }
      });

      // Background
      let background;
      let backgroundId = parseInt(urlParams.get('background'));
      for(let i=0; i<this.props.backgrounds.length; i++) {
        if(this.props.backgrounds[i].id == backgroundId) {
          background = this.props.backgrounds[i];
        }
      }

      let searches = [];
      // Images
      let images = [];
      let product, productId, variant, variantId, addSize, addSizes, addWidth, addHeight, loc, locX, locY, addTop, addLeft, frameId, frameVariantId, addingImage;
      let query
      let j = 1;
      do {
        productId = urlParams.get(`product_${j}`);
        variantId = urlParams.get(`variant_${j}`);
        loc = urlParams.get(`loc_${j}`);
        locX = loc.split('x')[0];
        locY = loc.split('x')[1];
        frameId = urlParams.get(`frame_${j}`);
        frameVariantId = urlParams.get(`frame_variant_${j}`);

        searches.push(
          {
            productId: productId,
            variantId: variantId,
            locX: locX,
            locY: locY,
            frame: frameId,
            frameVariant: frameVariantId
          }
        )
        j++
      } while (urlParams.has(`product_${j}`))


      for(let k=0; k < searches.length; k++) {
        query = client.query((root) => {
          root.add('product', {args: {id: searches[k].productId}}, (product) => {
            product.add('title');
            product.add('tags')
            product.addConnection('images', {args: {first: 1}}, (image) => {
              image.add('src');
              image.add('altText');
            });
            product.addConnection('variants', {args: {first: 100}}, (variant) => {
              variant.add('title');
              variant.add('price', (price) => {
                price.add('amount')
              })
              variant.add('selectedOptions', (selectedOptions) => {
                selectedOptions.add('value');
              });
            })
          });
        });

        let response = this.getProduct(query, searches[k]).then((data) => {
          variant = data.product.variants.edges.filter(obj => {
            return obj.node.id === data.search.variantId
          })[0];

          addSize = variant.node.selectedOptions[0].value.split(' cm')[0]
          addSizes = addSize.split('x');
          addWidth = parseInt(addSizes[0]);
          addHeight = parseInt(addSizes[1]);
          if(data.product.tags.indexOf('horizontal') > -1) {
            addHeight = parseInt(addSizes[0]);
            addWidth = parseInt(addSizes[1]);
          }

          addLeft = ($('.background-wrapper').width() * data.search.locX);
          addTop = ($('.background-wrapper').height() * data.search.locY);

          addingImage = {
            productId: data.product.id,
            variantId: variant.node.id,
            src: data.product.images.edges[0].node.src,
            alt: data.product.title,
            width: addWidth,
            height: addHeight,
            top: addTop,
            left: addLeft,
            frame: data.search.frame,
            frameVariant: data.search.frameVariant,
            variantPrice: parseFloat(variant.node.price.amount),
            framePrice: 0.0
          }
          images.push(addingImage);
          //_this.props.settingsSelectImage(addingImage);
        });

      }

      // Initial state
      initialState = {
        shop: this.props.shop,
        wallConfig: this.props.wallConfig,
        settings: {
          step: 3,
          apiVersion: this.props.apiVersion,
          background: background,
          backgroundSrc: urlParams.get('backgroundsrc'),
          foregroundSrc: urlParams.get('foregroundsrc'),
          backgroundColor: "Default",
          images: images,
          cart: []
        },
        faqs: this.props.faqs,
        products: [],
        backgrounds: this.props.backgrounds,
        frames: this.props.frames
      }
    } else {
     initialState = {
        shop: this.props.shop,
        wallConfig: this.props.wallConfig,
        settings: {
          step: 1,
          apiVersion: this.props.apiVersion,
          background: null,
          backgroundSrc: null,
          foregroundSrc: null,
          backgroundColor: "Default",
          images:[],
          cart: []
        },
        faqs: this.props.faqs,
        products: [],
        backgrounds: this.props.backgrounds,
        frames: this.props.frames
      }
    }

    const store = configureStore(initialState);
    return(
      <Provider store={store}>
        <Index
          logo={this.props.logo}
          introBackground={this.props.introBackground}
          step1={this.props.step1}
          step2={this.props.step2}
          step3={this.props.step3}
          step4={this.props.step4}
          editIcon={this.props.editIcon}
          cartIcon={this.props.cartIcon}
          searchIcon={this.props.searchIcon}
        />
      </Provider>
    )
  }
}

